import React, { PureComponent } from "react";
import { Card, Col, Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import { FormHeader, LeftIconHeader } from "components";
import "./PaymentPage.css";
import { connect } from "react-redux";
import PurchaseSummary from "./PurchaseSummary";
import { handleAmountCalc } from "../../../utils/helperFunctions";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { InterswitchPay } from "react-interswitch";
// import { navigate } from "@reach/router";
import axios from "axios";
import { config } from "constants/config";
import { handleError } from "appRedux/actions/Common";
import { useOperatorNavigate } from "utils/navigationHelper";

class PaymentPage extends PureComponent {
  state = {
    totalAmount: 0,
    transactionReference: "",
    isLoadingReference: false,
    showModal: false,
    getPayItemID:"",
    getMerchantCode:""
  };

  componentDidMount() {
    this.calculateTotalAmount();
  }

  calculateTotalAmount = () => {
    const { operatorTokensToBePurchased,countryProperties } = this.props;
    if (operatorTokensToBePurchased?.length > 0) {
      const total = handleAmountCalc(operatorTokensToBePurchased);
      const toKobo = total * 100;
      this.setState({ totalAmount: toKobo });
    }
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.operatorTokensToBePurchased !==
      prevProps.operatorTokensToBePurchased
    ) {
      this.calculateTotalAmount();
    }
  }

  handlePayNow = async () => {
    const { operatorTokensToBePurchased } = this.props;
    const firstToken = operatorTokensToBePurchased?.[0];
    
    if (!firstToken) return;
  
    this.setState({ isLoadingReference: true });
  
    const payload = {
      travelRouteId: firstToken.travelRouteId,
      unit: firstToken.units,
      tripId:firstToken.tripId,
      unitAmount: firstToken.amount,
      tokenType: "OPERATOR",
      operatorId: firstToken.operatorId,
      totalAmount: firstToken.amount * firstToken.units,
      customerEmail: firstToken?.email,
      customerPhoneNumber: firstToken.phone,
      customerName: firstToken?.name,
      nextOfKinPhoneNumber: firstToken?.nextOfKin,
      channel: "WHITELABEL",
      passengers: firstToken?.passengers
    };
  
    try {
      const response = await axios.post(
        `${config.tokenUrl}/tvp/token/whitelist/reference`,
        payload
      );
  
      this.setState({
        transactionReference: response.data?.data.transactionReference,
        isLoadingReference: false,
        showModal: true,
        getMerchantCode:response.data?.data?.merchantCode,
        getPayItemID:response.data?.data?.paymentItemId
      });
      
    } catch (error) {
      this.setState({ isLoadingReference: false });
  
      // Check for validation errors
      if (
        error.response &&
        error.response.status === 400 &&
        error.response.data?.validation
      ) {
        const validationErrors = error.response.data.validation;
  
        const firstField = Object.keys(validationErrors)[0];
        const errorMessage = validationErrors[firstField];
  
        handleError(`Validation error: ${errorMessage}`, error);
      } else {
        handleError(
          "Unable to generate payment reference. Please try again.",
          error?.message || error
        );
      }
  
      console.error("Error generating reference:", error);
    }
  };
  

  closeModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { operatorTokensToBePurchased, color, isCompleted,countryProperties } = this.props;
    const navigate = useOperatorNavigate()

    const {
      totalAmount,
      transactionReference,
      isLoadingReference,
      showModal,
    } = this.state;

    const firstToken = operatorTokensToBePurchased?.[0];

    if (!firstToken) {
      return (
        <Col sm="12">
          <div className="login-form x-form">
            <LeftIconHeader title="Payment" className="ml-0" />
            <div className="pad_holder">
              <Card className="login-form__card">
                <p className="text-center">
                  No token data available for payment.
                </p>
              </Card>
              <button type="button" className="btn mt-2" onClick={isCompleted}>
                <span className="login-form__bold-text_back">Back</span>
                <span className="back_arrow">
                  <ArrowLeftOutlined />
                </span>
              </button>
            </div>
          </div>
        </Col>
      );
    }

    return (
      <Col sm="12" md={{ size: 12, offset: 0 }}>
        <div className="login-form x-form">
          <LeftIconHeader title="Payment" className="spaceLeft" />
          <div className="pad_holder">
            <Card className="login-form__card">
              <FormHeader title="Purchase Summary" className="form-header2" />
              <hr />
              {operatorTokensToBePurchased.map((data) => (
                <PurchaseSummary
                  key={data.operatorId}
                  units={data.units}
                  operatorId={data.operatorId}
                  amount={data.amount}
                  selectedRoutes={data.selectedRoutes}
                  countryProperties={countryProperties}
                />
              ))}

              <button
                type="button"
                className="secondary-btn"
                onClick={this.handlePayNow}
                disabled={isLoadingReference}
                style={{
                  height: "45px",
                  borderRadius: "1px",
                  fontSize: "0.9rem",
                  background: color,
                }}
              >
                {isLoadingReference ? "Please wait..." : "Pay Now"}
              </button>
            </Card>

            <button type="button" className="btn mt-2" onClick={isCompleted}>
              <span className="login-form__bold-text_back" style={{marginLeft:"18px"}}>Back</span>
              <span className="back_arrow" aria-label="Go back">
                <ArrowLeftOutlined />
              </span>
            </button>
          </div>

          {/* Modal for confirmation */}
          <Modal isOpen={showModal} toggle={this.closeModal}>
            <ModalHeader toggle={this.closeModal}>Confirm Payment</ModalHeader>
            <ModalBody className="text-center">
              <p>
                You're about to proceed to payment. Do you want to continue?
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignContent: "center",
                  gap: "20px",
                  padding: "20px",
                }}
              >
                <Button
                  color="secondary"
                  onClick={this.closeModal}
                  style={{
                    width: "80%",
                    fontWeight: "bold",
                    fontSize: "16px",
                    padding: "10px",
                  }}
                >
                  Cancel
                </Button>

                <InterswitchPay
                  merchantCode={this.state.getMerchantCode}
                  payItemID={this.state.getPayItemID}
                  customerEmail={firstToken.email}
                  amount={totalAmount}
                  currency={countryProperties?.currency_numeric}
                  transactionReference={transactionReference}
                  redirectURL={window.location.origin}
                  text="Yes, Proceed"
                  mode={config.mode}
                  style={{
                    width: "80%",
                    height: "45px",
                    border: "none",
                    color: "#fff",
                    backgroundColor: color || "#0174d8",
                    fontWeight: "bold",
                    fontSize: "16px",
                    borderRadius: "5px",
                  }}
                  callback={(response) => {
                    if (response && ["00", "10"].includes(response.resp)) {
                      this.setState({ showModal: false });
                      navigate(
                        `/message?trxRef=${transactionReference}&merchantId=${this.state.getMerchantCode}`
                      );
                    } else if (response.resp === "09") {
                      this.setState({ showModal: false });
                      handleError(
                        "!OPS Sorry your payment is still pending, Kindly check your transaction history after a while "
                      );
                      navigate("/");
                    } else {
                      this.setState({ showModal: false });
                      handleError("Payment failed: " + (response?.desc || "Payment terminated"));
                      navigate("/reserve-seat-details");
                    }
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      </Col>
    );
  }
}

const mapStateToProps = ({
  buyOperatorState,
  selectOperatorState,
  searchState,
}) => {
  const selectedOperatorList = selectOperatorState.selectedOperators;
  const { userDetails } = searchState;
  const operatorTokensToBePurchased = buyOperatorState.operatorTokens;
  return {
    selectedOperatorList,
    operatorTokensToBePurchased,
    userDetails,
  };
};

export default connect(mapStateToProps)(PaymentPage);
